<template> <!-- 客户搜索 -->
  <el-select
    v-model="customerId"
    :loading="loading"
    :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
    style="width: 100%;"
    clearable
    filterable
    remote
    :multiple="multiple"
    :remote-method="asyncGetPage"
    @change="onChange"
    @clear="asyncGetPage"
  >
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
import { apiGetCustomerNewPage } from '@/api/finance/contasDeClientes';

const PARAM = {
  pageNumber: 1,
  pageSize: 10,
  params: {
    quickSearch: ''
  }
};
export default {
  props: {
    // 默认值
    val: {
      type: [String, Number, Array],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      customerId: '',
      list: [],
      loading: false
    };
  },

  watch: {
    val: {
      handler(val) {
        this.customerId = val;
        // 当val有值且list为空时，触发查询以回显数据
        if (val && this.list.length === 0) {
          this.$nextTick(() => {
            this.asyncGetPage();
          });
        }
      },
      immediate: true
    }
  },

  created() {
    // 初始化时如果没有customerId值，也请求一次显示默认列表
    if (!this.customerId) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.asyncGetPage();
        }, 300);
      });
    }
  },

  methods: {
    asyncGetPage(name = '') {
      PARAM.params.quickSearch = name;
      // 有搜索词时清空customerIdList，无搜索词时根据customerId回显
      const hasCustomerId = this.customerId || (Array.isArray(this.customerId) && this.customerId.length > 0);
      console.log('customerId', this.customerId, hasCustomerId);
      PARAM.params.customerIdList = name ? null : (hasCustomerId ? (Array.isArray(this.customerId) ? this.customerId : [this.customerId]) : []);
      this.loading = true;
      this.list = [];
      apiGetCustomerNewPage(PARAM, false).then(res => {
        this.list = (res.data.records || []).map(item => {
          const { id, customerAlias, username } = item;
          const obj = {
            ...item,
            value: id,
            label: this.type === 1 ? username : `${customerAlias}(${username})`
          };
          return Object.freeze(obj);
        });
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },

    onChange(e) {
      this.$emit('change', e);
    }
  }

};
</script>

<style scoped>
</style>
